// src/admin/BlockLeaderManagement.js - Thêm tab Sơ yếu lý lịch GLV
import React, { useContext } from 'react';
import { NavLink, Outlet, Navigate } from 'react-router-dom';
import TopNav from '../components/TopNav';
import { StudentContext } from '../StudentContext';
import './BlockLeaderManagement.css';

// Helper chuẩn hóa Tiếng Việt để so sánh tên Khối/Ngành linh hoạt
const cleanVietnameseText = (str) => {
  if (!str) return '';
  let slug = str.toString().toLowerCase();
  slug = slug.replace(/đ/g, 'd');
  slug = slug.replace(/[áàảãạăắằẳẵặâấầẩẫậ]/g, 'a');
  slug = slug.replace(/[éèẻẽẹêếềểễệ]/g, 'e');
  slug = slug.replace(/[íìỉĩị]/g, 'i');
  slug = slug.replace(/[óòỏõọôốồổỗộơớờởỡợ]/g, 'o');
  slug = slug.replace(/[úùủũụưứừửữự]/g, 'u');
  slug = slug.replace(/[ýỳỷỹỵ]/g, 'y');
  slug = slug.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  slug = slug.replace(/khoi\s+/g, ''); // Loại bỏ tiền tố "khối" để so sánh cốt lõi
  return slug.trim();
};

const BlockLeaderManagement = () => {
  const { allBlocks, isLoading, isDataLoaded } = useContext(StudentContext);

  const userRole = localStorage.getItem('userRole') || 'catechist';
  const blockLeader = localStorage.getItem('blockLeader') || '';
  const isAdmin = userRole === 'admin';

  // --- BỘ BẢO VỆ ROUTE ĐỒNG BỘ ĐỘNG THEO FIRESTORE ---
  const isAuthorizedBlockLeader = () => {
    if (isAdmin) return true;
    if (!blockLeader || !blockLeader.trim()) return false;

    const userBlockClean = cleanVietnameseText(blockLeader);

    // 1. So sánh với danh sách Khối/Ngành có trong Niên khóa hiện tại từ StudentContext
    const groupNamesInFirestore = Object.keys(allBlocks || {}).map((groupCleanId) => {
      const classesInGroup = allBlocks[groupCleanId];
      return classesInGroup[0]?.group || '';
    });

    if (groupNamesInFirestore.length > 0) {
      const isMatched = groupNamesInFirestore.some((gName) => {
        const cleanGName = cleanVietnameseText(gName);
        return (
          userBlockClean === cleanGName ||
          userBlockClean.includes(cleanGName) ||
          cleanGName.includes(userBlockClean)
        );
      });
      if (isMatched) return true;
    }

    // 2. Dự phòng (Fallback) nếu Context chưa kịp tải xong
    const fallbackBlocks = ['Khai Tâm', 'Rước Lễ', 'Thêm Sức', 'Bao Đồng', 'Chiên Con', 'Dự Bị'];
    return fallbackBlocks.some((b) => userBlockClean.includes(cleanVietnameseText(b)));
  };

  // Trạng thái chờ nạp Niên khóa hiện tại
  if (isLoading && !isDataLoaded && !isAdmin) {
    return (
      <div className="blm-page-container">
        <TopNav />
        <div style={{ textAlign: 'center', padding: '100px 20px', color: '#64748b' }}>
          ⏳ Đang xác thực quyền Trưởng Khối...
        </div>
      </div>
    );
  }

  // Nếu KHÔNG phải Admin VÀ KHÔNG thuộc Khối hợp lệ -> Điều hướng về /main
  if (!isAuthorizedBlockLeader()) {
    return <Navigate to="/main" replace />;
  }

  // Render thanh Menu Tabs ngang
  const renderNavTabs = () => {
    const navLinkClasses = ({ isActive }) =>
      `blm-nav-link ${isActive ? 'blm-nav-link-active' : ''}`;

    return (
      <nav className="blm-nav-tabs">
        <ul className="blm-nav-list">
          <li className="blm-nav-item">
            <NavLink to="catechist-attendance" className={navLinkClasses}>
              ⛪ Điểm danh Giáo Lý Viên
            </NavLink>
          </li>
          <li className="blm-nav-item">
            <NavLink to="leave-requests" className={navLinkClasses}>
              📝 Duyệt Đơn Xin Nghỉ
            </NavLink>
          </li>
          {/* 🌟 TAB MỚI: SƠ YẾU LÝ LỊCH GLV 🌟 */}
          <li className="blm-nav-item">
            <NavLink to="catechist-cv" className={navLinkClasses}>
              🗂️ Sơ yếu lý lịch GLV
            </NavLink>
          </li>
        </ul>
      </nav>
    );
  };

  return (
    <div className="blm-page-container">
      {/* Thanh điều hướng TopNav */}
      <TopNav />

      {/* Thanh Menu Tabs */}
      {renderNavTabs()}

      {/* Khu vực nội dung chính */}
      <div className="blm-content-wrapper">
        <main className="blm-main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default BlockLeaderManagement;